import { Grid } from "@mui/material";
import React from "react";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";

export default function NozzlesPanel() {
  const table = useMaterialReactTable({
    ...lightTable,
    data: [{ component: "N1" }, { component: "N2" }, { component: "MW1A" }],
    columns: [
      {
        accessorKey: "Mark",
        header: "Mark",
        size: 10,
      },
      {
        accessorKey: "Service",
        header: "Service",
        size: 10,
      },
      {
        accessorKey: "Size",
        header: "Size",
        size: 10,
      },
      {
        accessorKey: "Type",
        header: "Type",
        size: 10,
      },
      {
        accessorKey: "Flange Rating",
        header: "Flange Rating",
        size: 10,
      },
      {
        accessorKey: "Sch / Thk",
        header: "Sch / Thk",
        size: 10,
      },
      {
        accessorKey: "Weld Detail",
        header: "Weld Detail",
        size: 10,
      },
      {
        accessorKey: "Nozzle Weld (A) (in)",
        header: "Nozzle Weld (A) (in)",
        size: 10,
      },
      {
        accessorKey: "Inside Weld (B) (in)",
        header: "Inside Weld (B) (in)",
        size: 10,
      },
      {
        accessorKey: "Pad Weld (C) (in)",
        header: "Pad Weld (C) (in)",
        size: 10,
      },
      {
        accessorKey: "Outside Proj (in)",
        header: "Outside Proj (in)",
        size: 10,
      },
      {
        accessorKey: "Inside Proj (in)",
        header: "Inside Proj (in)",
        size: 10,
      },
      {
        accessorKey: "Pad OD (in)",
        header: "Pad OD (in)",
        size: 10,
      },
      {
        accessorKey: "Pad Thk (in)",
        header: "Pad Thk (in)",
        size: 10,
      },
      {
        accessorKey: "Attachment",
        header: "Attachment",
        size: 10,
      },
      {
        accessorKey: "BlindFlange",
        header: "BlindFlange",
        size: 10,
      },
    ],
  });
  return (
    <Grid container>
      <Grid item xs={8} sx={{ pt: 2 }}>
        <InputGroupShape name="Nozzles Details">
          <MaterialReactTable table={table} />
        </InputGroupShape>
      </Grid>
      <Grid item xs={4} sx={{ pt: 2 }}>
        <InputGroupShape name="Material Data">
          <MaterialReactTable table={table} />
        </InputGroupShape>
      </Grid>
    </Grid>
  );
}
